import SelectionCheckboxInput from './SelectionCheckboxInput';

export default SelectionCheckboxInput;